<template>
  <div>
    <div class="box">
      <div class="column1">
        <div class="row">
          <div
            class="row1-tabCom"
            style="padding: 10px; box-sizing: border-box"
          >
            <div
              id="personnelInformation"
              style="width: 100%; height: 90%"
            ></div>
            <div>
              <el-tabs stretch v-model="activeName" @tab-click="handleClick">
                <!-- 岗位 -->
                <el-tab-pane :label="`岗位`" name="jobPosition"></el-tab-pane>
                <!-- 男女 -->
                <el-tab-pane :label="`性别`" name="gender"></el-tab-pane>
                <!-- 学历 -->
                <el-tab-pane
                  :label="`学历`"
                  name="educationalBackground"
                ></el-tab-pane>
                <!-- 职称 -->
                <el-tab-pane
                  :label="`职称`"
                  name="professionalTitle"
                ></el-tab-pane>
              </el-tabs>
            </div>
          </div>

          <div id="aonsumablesInformation" class="row1-tabCom"></div>
          <div id="deviceInformation" class="row1-tabCom"></div>
        </div>
        <div class="row row2">
          <div class="row2-tabComFar">
            <div style="" class="row2-tabCom">
              <template v-if="haveInstrumentInformation">
                <!-- 器械信息 -->
                <div style="text-align: center;color:#666;font-weight: 800;margin-top: 10px;">器械统计</div>
                <!-- 暂无数据 -->
                <el-empty :description="`暂无数据`" ></el-empty>
              </template>
              <div id="instrumentInformation" v-else  style="width: 98%;height: 100%;"></div>
            </div>
          </div>
          <div class="row2-tabComFar">
            <div class="row2-tabCom">
              <template v-if="haveInstrumentKitInformation">
                <!-- 器械包信息 -->
                <div style="text-align: center;color:#666;font-weight: 800;margin-top: 10px;">器械包统计</div>
                <!-- 暂无数据 -->
                <el-empty :description="`暂无数据`"  ></el-empty>
              </template>
              <div id="instrumentKitInformation" v-else style="width: 98%;height: 100%;"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="column2">
        <div class="d-flex between">
          <div class="column2-row-box" @click="toPage('/basic/person/index')">
            <div class="d-flex center">
              <i class="el-icon-user icon"></i>
              <span class="iconText">{{ personnel }}</span>
            </div>
            <!-- 人员 -->
            <div style="text-align: center">人员</div>
          </div>
          <div class="column2-row-box" @click="toPage('/basic/instrument/index')">
            <div class="d-flex center">
              <i class="el-icon-scissors icon"></i>
              <span class="iconText">{{ equipment }}</span>
            </div>
            <!-- 器械 -->
            <div style="text-align: center">器械</div>
          </div>
        </div>
        <div class="d-flex between">
          <div class="column2-row-box" @click="toPage('/basic/instrument-package/index')">
            <div class="d-flex center">
              <i class="el-icon-suitcase icon"></i>
              <span class="iconText">{{ equipmentBag }}</span>
            </div>
            <!-- 器械包 -->
            <div style="text-align: center">器械包</div>
          </div>
          <div class="column2-row-box" @click="toPage('/basic/machine/index')">
            <div class="d-flex center">
              <i class="el-icon-set-up icon"></i>
              <span class="iconText">{{ device }}</span>
            </div>
            <!-- 设备 -->
            <div style="text-align: center">设备</div>
          </div>
        </div>
        <div class="column2-row1" style="height: 40%">
          <div id="departmentInformation" class="column2-row3"></div>
        </div>
        <div class="column2-row1" style="height: 40%">
          <div id="supplierInformation" class="column2-row3"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import echarts from "echarts/lib/echarts"; // 引入 ECharts 主模块
import "echarts/lib/chart/bar"; // 引入柱状图
import "echarts/lib/chart/pie"; // 引入饼图
export default {
  data() {
    return {
      personnel: "",
      equipment: "",
      equipmentBag: "",
      device: "",
      activeName: "jobPosition",
      mapData: [],
      haveInstrumentInformation:false,//展示空状态
      haveInstrumentKitInformation:false
    };
  },
  mounted() {
    // 获取数据
    this.getData();
  },
  methods: {
    //跳转到对应的页
    toPage(roter){
      this.$router.push(roter)
    },
    // 标签页切换时的事件
    handleClick(tab, event) {
      let total = this.mapData.user_info.user_total_number;
      let xAxis = [];
      let seriesData = [];
      if (this.activeName == "jobPosition") {
        for (let item of this.mapData.user_info.userCount1) {
          xAxis.push(item[0]);
          seriesData.push(item[1]);
        }
      } else if (this.activeName == "gender") {
        for (let item of this.mapData.user_info.userCount2) {
          xAxis.push(item[0]);
          seriesData.push(item[1]);
        }
      } else if (this.activeName == "educationalBackground") {
        xAxis = this.mapData.user_info.userKey3;
        seriesData = this.mapData.user_info.userCount3;
      } else if (this.activeName == "professionalTitle") {
        for (let item of this.mapData.user_info.userCount4) {
          xAxis.push(item[0]);
          seriesData.push(item[1]);
        }
      }
      // 人员信息表
      this.createPersonnelInformation(xAxis, seriesData, total);
    },
    // 发起网络请求，得到数据
    getData() {
      this.$request("get", "/api/homepage/statistics").then((res) => {
        this.mapData = res;
        this.handleClick();
        this.personnel = res.user_info.user_total_number; //人员
        this.equipment = res.instrument.instrument_total_number; //器械
        this.equipmentBag = res.instrumentset_info.instrumentset_number; //器械包
        this.device = res.equipment_info.equipment_total_number; //设备
        // // 人员信息表
        // this.createPersonnelInformation(res.user_info);
        // 耗材信息表
        this.createAonsumablesInformation(res.instrument_info);
        // 设备信息
        this.createDeviceInformation(res.equipment_info);
        // 器械信息
        this.createInstrumentInformation(res.instrument);
        // 器械包信息
        this.createInstrumentKitInformation(res.instrumentset_info);
        //科室信息
        this.createDepartmentInformation(res.department_info);
        // 供应商信息
        this.createSupplierInformation(res.vendor_info);
      });
    },
    // 创建echarts表格 的公共函数
    createMap(eleId, option) {
      var myChart = this.$echarts.init(document.getElementById(eleId));
      myChart.setOption(option);
    },
    // 人员信息表
    createPersonnelInformation(xAxis, seriesData, total) {
      var option = {
        title: {
          // 人员信息
          text: `人员统计`,
          left: "center",
          top: 10,
          textStyle: { color: "#666", fontSize: 16 },
        },
        grid: {
          top: 80, // 设定图表顶部边距
          // left: "8%",
          // right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        legend: {
          // 人数
          data: [""+`人数`+""],
          top: 42, // 距离顶部5%
          right: "5%", // 距离右侧5%
          icon: "circle", // 将图例标记设为圆形
        },
        tooltip: {
            trigger: 'item',
            // 数量
            formatter: "{b} <br/>"+`数量`+": {c}"
        },
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: 50,
              style: {
                // 总计
                text: ""+`总计`+":"+total,
                fill: "#999",
              },
            },
          ],
        },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          // 人数(个)
          name: `人数(个)`,
          nameLocation: "middle", // 将单位信息居中显示
          nameGap: 40, // 将单位信息与轴线之间的距离设为 20
          type: "value",
        },
        series: [
          {
            // 人数
            name: ""+`人数`+"",
            data: seriesData,
            type: "bar",
            width: "90%",
            itemStyle: {
              normal: {
                color: "#04a1ec", // 指定柱子颜色
              },
            },
          },
        ],
      };
      this.createMap("personnelInformation", option);
    },
    // 耗材信息表
    createAonsumablesInformation(datas) {
      let data = [];
      let legendData = [];
      for (let i = 0; i < datas.instrument_data.length; i++) {
        let obj = {};
        obj.name = datas.instrument_data[i][0];
        obj.value = datas.instrument_data[i][1];
        data.push(obj);
        legendData.push(datas.instrument_data[i][0]);
      }
      var option = {
        title: {
          // 耗材信息
          text: `耗材统计`,
          left: "center",
          top: 20,
          textStyle: { color: "#666", fontSize: 16 },
        },
        legend: {
          data: legendData,
          itemWidth: 14, // 图例标记的图形宽度
          itemHeight: 14, // 图例标记的图形高度
          icon: "circle", // 将图例标记设为圆形
          bottom: 10,
        },
        grid: {
          top: 80, // 设定图表顶部边距
          left: "10%",
          right: "10%",
          bottom: "3%",
          containLabel: true,
        },
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: 50,
              style: {
                // 总计
                text: ""+`总计`+ ":" + datas.instrument_total_number,
                fill: "#999",
              },
            },
          ],
        },
        tooltip: {
            trigger: 'item',
            // 数量
            formatter: "{b} <br/>"+`数量`+": {c}"
        },
        series: [
          {
            type: "pie",
            radius: [40, 80],
            left: "center",
            width: "90%",
            itemStyle: { borderColor: "#fff", borderWidth: 1 },
            label: {
              alignTo: "edge",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: { time: { fontSize: 10, color: "#999" } },
            },
            labelLine: { length: 10, length2: 0, maxSurfaceAngle: 80 },
            data: data,
            legendHoverLink: true, // 启用图例联动高亮
          },
        ],
      };
      this.createMap("aonsumablesInformation", option);
    },
    // 设备信息
    createDeviceInformation(datas) {
      let xAxisData = [];
      for (let i = 0; i < datas.equipment_type.length; i++) {
        xAxisData.push(datas.equipment_type[i].name);
      }
      var option = {
        title: {
          // 设备信息
          text: `设备统计`,
          left: "center",
          top: 20,
          textStyle: { color: "#666", fontSize: 16 },
        },
        tooltip: {
            trigger: 'item',
            // 数量
            formatter: "{b} <br/>"+`数量`+": {c}"
        },
        grid: {
          top: 80, // 设定图表顶部边距
          left: "10%",
          right: "10%",
          bottom: "3%",
          containLabel: true,
        },
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: 50,
              style: {
                // 总计
                text: ""+`总计`+ ":" + datas.equipment_total_number,
                fill: "#999",
              },
            },
          ],
        },
        xAxis: {
          type: "category",
          data: xAxisData,
        },
        yAxis: {
          // 数量（台）
          name: `数量(台)`,
          nameLocation: "middle", // 将单位信息居中显示
          nameGap: 40, // 将单位信息与轴线之间的距离设为 20
          type: "value",
        },
        color: [
          "#C1232B",
          "#27727B",
          "#FCCE10",
          "#E87C25",
          "#B5C334",
          "#FE8463",
        ],
        series: [
          {
            data: datas.equipment_count,
            type: "bar",
            itemStyle: {
              normal: {
                // 通过 dataIndex 取余实现循环设色效果
                color: function (params) {
                  return option.color[params.dataIndex % option.color.length];
                },
              },
            },
          },
        ],
      };
      this.createMap("deviceInformation", option);
    },
    // 器械信息
    createInstrumentInformation(datas) {
      if(datas.instrument_data.length == 0){
        this.haveInstrumentInformation = true
          return
      } else {
        this.haveInstrumentInformation = false
      }
      let yAxisData = [];
      let xAxisData = [];
      for (let item in datas.instrument_data) {
        yAxisData.push(datas.instrument_data[item][0]);
        xAxisData.push(datas.instrument_data[item][1]);
      }
      let chartHeight = 50 + yAxisData.length * 17
      var myDiv = document.getElementById('instrumentInformation');
      if(myDiv.offsetHeight>chartHeight){
        myDiv.style.height = myDiv.offsetHeight
      }else{
        myDiv.style.height = chartHeight + 'px'
      }
      var option = {
        title: {
          // 器械信息
          text: `器械统计`,
          left: "center",
          top: 20,
          textStyle: { color: "#666", fontSize: 16 },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          // 数量
          data: [""+`数量`+""],
          top: 30, // 距离顶部5%
          right: "5%", // 距离右侧5%
          borderWidth: 1, // 边框宽度为1像素
          borderColor: "#777", // 边框颜色为红色
          shadowBlur: 1, //阴影模糊半径
          shadowColor: "black", //阴影颜色
          padding: [5, 10], // 上下10像素，左右20像素
          icon: "circle", // 将图例标记设为圆形
        },
        grid: {
          top: 80, // 设定图表顶部边距
          left: "1%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: 50,
              style: {
                // 总计
                text: ""+`总计`+ ":" + datas.instrument_total_number,
                fill: "#999",
              },
            },
          ],
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: yAxisData,
          axisLabel: {
            interval: 0
          }
        },
        series: [
          {
            // 数量
            name: `数量`,
            type: "bar",
            data: xAxisData,
            barWidth:5,
            label: {
              show: true,
              position: "right", // 标签放在条形图右侧
            },
            itemStyle: {
              color: "#04a1ec", // 设置柱子颜色为绿色
            },
          },
        ],
      };
      this.createMap("instrumentInformation", option);
    },
    // 器械包信息
    createInstrumentKitInformation(datas) {
      if(datas.instrumentset_data.length == 0){
        this.haveInstrumentKitInformation = true
          return
      }else{
        this.haveInstrumentKitInformation = false
      }
      let yAxisData = [];
      let seriesData = [];
      for (const key in datas.instrumentset_data) {
        let name = datas.instrumentset_data[key].name;
        let value = datas.instrumentset_data[key].count;
        yAxisData.push(name);
        seriesData.push(value);
      }
      let chartHeight = 50 + yAxisData.length * 17
      var myDiv = document.getElementById('instrumentKitInformation');

      if(myDiv.offsetHeight>chartHeight){
        myDiv.style.height = myDiv.offsetHeight
      }else{
        myDiv.style.height = chartHeight + 'px'
      }

      var option = {
        title: {
          // 器械包信息
          text: `器械包统计`,
          left: "center",
          top: 20,
          textStyle: { color: "#666", fontSize: 16 },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          // 数量
          data: [""+`数量`+""],
          top: 30, // 距离顶部5%
          right: "5%", // 距离右侧5%
          borderWidth: 1, // 边框宽度为1像素
          borderColor: "#777", // 边框颜色为红色
          shadowBlur: 1, //阴影模糊半径
          shadowColor: "black", //阴影颜色
          padding: [5, 10], // 上下10像素，左右20像素
          icon: "circle", // 将图例标记设为圆形
        },
        grid: {
          top: 80, // 设定图表顶部边距
          left: "1%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        graphic: {
          elements: [
            {
              type: "text",
              left: "center",
              top: 50,
              style: {
                // 总计
                text: ""+`总计`+ ":" + datas.instrumentset_number,
                fill: "#999",
              },
            },
          ],
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: yAxisData,
          axisLabel: {
            interval: 0
          }
        },
        series: [
          {
            // 数量
            name: `数量`,
            type: "bar",
            barWidth:5,
            data: seriesData,
            label: {
              show: true,
              position: "right", // 标签放在条形图右侧
            },
            itemStyle: {
              color: "#04a1ec", // 设置柱子颜色为绿色
            },
          },
        ],
      };
      this.createMap("instrumentKitInformation", option);
    },
    // 科室信息表
    createDepartmentInformation(datas) {
      let legendData = [];
      let data = [];
      for (let item of datas.department_data) {
        legendData.push(item[0]);
        data.push({
          name: item[0],
          value: item[1],
        });
      }
      var option = {
        title: {
          // 科室信息
          text: `科室统计`,
          left: "center",
          top: 20,
          textStyle: { color: "#666", fontSize: 16 },
        },
        legend: {
          data: legendData,
          itemWidth: 14, // 图例标记的图形宽度
          itemHeight: 14, // 图例标记的图形高度
          icon: "circle", // 将图例标记设为圆形
          bottom: 10,
        },
        tooltip: {
            trigger: 'item',
            // 数量
            formatter: "{b} <br/>"+`数量`+": {c}"
        },
        series: [
          {
            type: "pie",
            radius: [30, 70],
            left: "center",
            itemStyle: { borderColor: "#fff", borderWidth: 1 },
            width: "90%",
            label: {
              alignTo: "edge",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: { time: { fontSize: 10, color: "#999" } },
            },
            labelLine: {
              length: 30,
              length2: 0,
              maxSurfaceAngle: 80,
              normal: {
                show: true,
                smooth: true, // 设置labelLine为光滑曲线
              },
            },
            data: data,
            legendHoverLink: true, // 启用图例联动高亮
          },
        ],
      };
      this.createMap("departmentInformation", option);
    },
    // 供应商信息
    createSupplierInformation(datas) {
      let legendData = [];
      let data = [];
      for (let item of datas.vendor_data) {
        legendData.push(item[0]);
        data.push({
          name: item[0],
          value: item[1],
        });
      }
      var option = {
        title: {
          // 供应商信息
          text: `供应商统计`,
          left: "center",
          top: 20,
          textStyle: { color: "#666", fontSize: 16 },
        },
        legend: {
          data: legendData,
          itemWidth: 14, // 图例标记的图形宽度
          itemHeight: 14, // 图例标记的图形高度
          icon: "circle", // 将图例标记设为圆形
          bottom: 10,
        },
        tooltip: {
            trigger: 'item',
            // 数量
            formatter: "{b} <br/>"+`数量`+": {c}"
        },
        series: [
          {
            type: "pie",
            radius: [30, 70],
            top: "10%",
            height: "63.33%",
            left: "center",
            width: "90%",
            itemStyle: { borderColor: "#fff", borderWidth: 1 },
            label: {
              alignTo: "edge",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: { time: { fontSize: 10, color: "#999" } },
            },
            labelLine: {
              length: 10,
              length2: 0,
              maxSurfaceAngle: 80,
              normal: {
                show: true,
                smooth: true, // 设置labelLine为光滑曲线
              },
            },
            data: data,
            legendHoverLink: true, // 启用图例联动高亮
          },
        ],
      };
      this.createMap("supplierInformation", option);
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
}
.column1 {
  /* flex: 3; */
  width: 75%;
  margin-right: 20px;
}
.column2 {
  /* flex: 1; */
  width: 23%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.row1-tabCom {
  width: 32%;
  height: 400px;
  background-color: #fff;
  border-radius: 10px;
}
.row2-tabComFar{
  width: 48%;
  height: 400px;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px 5px;
}
.row2-tabCom {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.row {
  display: flex;
  justify-content: space-between;
}
.row2 {
  margin-top: 20px;
}
.column2-row-box {
  background-color: #fff;
  width: 48%;
  border-radius: 10px;
  padding: 8px 0;
}
.column2-row3 {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 10px;
}
.icon {
  font-size: 25px;
  margin-right: 10px;
}
.iconText {
  color: #777;
  font-size: 20px;
}
</style>